// extracted by mini-css-extract-plugin
export default {"Container":"AttributeRowFollowers-module__Container__Gvv5K","Image":"AttributeRowFollowers-module__Image__po9Xw"};